import useTranslation from "src/hooks/useTranslation";
import { SingleSelection } from "../GeneralSelection";
import { useFilterOptions } from "./hooks/useFilterOptions";
import { SelectChangeEvent } from "../MuiGenerals";

function CurrencySingleSelection({
  fieldName,
  value,
  onChange,
  onClear,
  chainName,
}: {
  fieldName: string;
  value: string;
  onChange: (e: SelectChangeEvent<string>) => void;
  onClear?: () => void;
  chainName: string;
}) {
  const { tc } = useTranslation("common");

  const { getCurrencySelectOptions } = useFilterOptions();

  return (
    <SingleSelection
      value={value}
      label={tc("phSelection", { fieldName })}
      onChange={onChange}
      enumData={getCurrencySelectOptions(chainName)}
      nameFn={(name) => name}
      clearSelect={onClear || (() => {})}
    />
  );
}

export default CurrencySingleSelection;
